"use strict";

exports.__esModule = true;
exports.AggregateMetricChartController = AggregateMetricChartController;
var _react = _interopRequireDefault(require("react"));
var _APIQueryController = require("../../../API/APIQueryController");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AggregateMetricChartController(props) {
  var query = props.query,
    children = props.children;
  return /*#__PURE__*/_react["default"].createElement(_APIQueryController.APIQueryController, {
    url: "/api/v3/timeseries-metrics/flattened",
    method: "POST",
    body: query
  }, children);
}